<template>
  <div class="icon-picker-container">
    <div class="icon-picker-search">
      <!-- search -->
      <i class="icon-picker-search__icon fa fa-search" />
      <input
        placeholder="Search..."
        class="icon-picker-search__input"
        v-model="searchTerm"
        type="text"
      />
    </div>

    <div class="icon-picker">
      <!-- icon selection -->
      <div
        class="icon-picker__icon"
        :class="{
                    'icon-picker__icon--selected': currentIcon === icon 
                }"
        v-for="(icon, key) in filteredIcons"
        :key="key"
        @click="selectIcon(icon)"
      >
        <i class="fa" :class="'fa-' + icon" ></i>
      </div>
      <div v-if="filteredIcons.length === 0">No icons found</div>
    </div>
  </div>
</template>

<script>
import icons from "@/utils/icons";
import { EventBus } from "@/event-bus.js";

export default {
  props: {
    selectedIcon: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      currentIcon: this.selectedIcon,
      searchTerm: ""
    };
  },

  computed: {
    filteredIcons() {
      return icons.filter(
        val => val.indexOf(this.searchTerm.toLowerCase()) !== -1
      );
    }
  },

  methods: {
    selectIcon(name) {      
      this.currentIcon = name;
      EventBus.$emit("ICON_SELECT", name);
    }
  }
};
</script>

<style lang="sass" scoped>
@import "@/assets/styles/variables.scss"

.icon-picker-container
    width: 100%
    padding: 2rem
    display: flex
    flex-direction: column
    justify-content: center

.icon-picker
    display: flex
    align-items: flex-start
    justify-content: center
    flex-wrap: wrap
    max-height: 200px
    overflow-y: scroll

    &__icon
        border-radius: 10px
        padding: .5rem 1rem
        margin: .3rem
        cursor: pointer
        color: $improve-navy

        &--selected
            background-color: $improve-grey
            
        &:hover
            background-color: $improve-grey

.icon-picker-search
    display: flex
    align-items: center
    justify-content: center

    padding-bottom: 2px
    border-bottom: 1px solid $improve-navy

    margin-bottom: 5px

    &__icon
        margin-right: 5px

    &__input
        width: 100%
        padding: 2px
        outline: none

    &::placeholder
        font-size: .9rem
</style>